import { FuelType } from 'src/pages/FuelTracking/enums'

export const DEFAULT_VALUES_FUEL_STATE = {
  date: new Date(),
  address: '',
  odometer: '',
  fuelQuantity: '',
  pricePerLiter: '',
  fuelType: FuelType.PETROL95,
  totalCost: '',
}
